/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import {CookiesProvider} from "react-cookie";
// core components
import Admin from "layouts/Admin.js";
import ChangePassword from "layouts/authentication/password";
import { ThemeProvider } from "@mui/material/styles";
import theme from "assets/theme";
import { MaterialUIControllerProvider } from "context";
import "assets/css/material-dashboard-react.css?v=1.9.0";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import 'react-toastify/dist/ReactToastify.css';

const hist = createBrowserHistory();
export const queryClient = new QueryClient();

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <CookiesProvider>
    <StyledEngineProvider injectFirst>   
    <MaterialUIControllerProvider>
      <ThemeProvider theme={theme}>
        <Router history={hist}>
          <Switch>
            <Route path='/docs' component={() => {
                 window.location.href = '/docs';
                 return null;
            }}/>
             <Route path='/pwd' component={ChangePassword}/>
            <Route path="/admin" component={Admin} />
            <Redirect from="/" to="/admin/dashboard" />
          </Switch>
        </Router>
      </ThemeProvider>
    </MaterialUIControllerProvider>
    </StyledEngineProvider>
    </CookiesProvider>
    <ReactQueryDevtools />
  </QueryClientProvider>,
  document.getElementById("root")
);
